import React from 'react'
import { FaYoutube } from 'react-icons/fa';
import {
    FooterContainer,
    FooterLink,
    FooterLinkTitle,
    FooterLinksContainer,
    FooterLinksWrapper,
    FooterLinksItems,
    } from "../Footer/Footer.elements";

function Education() {
    return (
        <FooterContainer>  
            <FooterLinksContainer>
                <FooterLinksWrapper>
                    <FooterLinksItems>
                        <FooterLinkTitle>Education</FooterLinkTitle>
                        <FooterLink>Msc. Computer Science </FooterLink>
                        <FooterLink>Bsc. Computer Science </FooterLink>
                        <FooterLink>The Business of Urban Farming </FooterLink>                        
                    </FooterLinksItems>
                    <FooterLinksItems>
                        <FooterLinkTitle>Intrested In</FooterLinkTitle>
                        <FooterLink> Business Analysis </FooterLink>
                       <FooterLink> Product Designing & Development</FooterLink>   
                      <FooterLink> Autonomous vehicle Development </FooterLink>  
                      <FooterLink> AI based IoT Product Development </FooterLink>  
                      <FooterLink> Green Enegry Development </FooterLink>                         
                    </FooterLinksItems>
                    <FooterLinksItems>
                        <FooterLinkTitle>Specialization</FooterLinkTitle>
                        <FooterLink>Deep Learning</FooterLink>                                                                      
                        <FooterLink>Advance Machine Learning with TensorFlow on GCP</FooterLink>                                                                      
                        <FooterLink>Self Driving Car</FooterLink>                                                                      
                        <FooterLink>Google Cloud App Development</FooterLink>                                                                      
                        <FooterLink>Enegry Production Distribution & Safety</FooterLink>                                                                      
                        <FooterLink>MERN Developer</FooterLink>      
                        <FooterLink>Full Stack Django Developer</FooterLink>      
                        <FooterLink>Angular Developer</FooterLink>      

                    </FooterLinksItems>
                    <FooterLinksItems>
                        <FooterLinkTitle>Special Thanks </FooterLinkTitle>
                        <FooterLink>Team of React Js</FooterLink>
                        <FooterLink>Facebook & Youtube  </FooterLink>
                          <FooterLink> <FaYoutube/> Brad Traversy, Sendex, Rebellionrider, Naveen Sir, Hitesh sir, Brain Design </FooterLink> 
                           <FooterLink>Graphics https://stories.freepik.com/  https://undraw.com/                             
                             </FooterLink>                                               
                    </FooterLinksItems>                    
                </FooterLinksWrapper>
            </FooterLinksContainer>
            </FooterContainer>
    )
}

export default Education;

